import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import _ from 'lodash'
import ManageAssets from '../../dump/menuComponents/ManageAssets'
import GreyHeader from '../../../component/dump/menuComponents/GreyHeader'

const ManageVehicles = (props) => {

	const { user } = props;
	const userRole = user.roles[0];
	const userPermissions = user.permissions;

	const [tabKey, setTabKey] = useState(_.get(props, 'location.state.tabKey') || 1);
	const [selectedProfileName, setSelectedProfileName] = useState(_.get(props, 'location.state.profile_name') || '');
	const [device_id, setDevice_id] = useState(_.get(props, 'location.state.device_id') || null);

	const selectProfile = (e) => {
		setSelectedProfileName(e.target.name)
		setDevice_id('all')
	}

	const headerOptions = {
		title: 'Partner Portal'
	}

	headerOptions.renderSubtitle = (
		<nav className="page-subtitle">
			<div>Vehicles</div>
		</nav>
	);

	return (
		<>
			<GreyHeader {...headerOptions} />
			<ManageAssets
				selectProfile={selectProfile}
			/>
		</>
	);
}

ManageVehicles.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
	}),
)(ManageVehicles);
